import { type ParsedBreadcrumb } from '@shared/component/VBreadcrumb/types';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useBreadcrumbStore = defineStore('breadcrumbStore', () => {
  const breadcrumbs = ref<ParsedBreadcrumb[]>([]);

  return {
    breadcrumbs,
  };
});
